"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListValueSource = void 0;

var _ConditionalAssignment = require("./ConditionalAssignment");

var _ValueSource2 = require("./ValueSource");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ListValueSource = /*#__PURE__*/function (_ValueSource) {
  _inherits(ListValueSource, _ValueSource);

  var _super = _createSuper(ListValueSource);

  function ListValueSource() {
    _classCallCheck(this, ListValueSource);

    return _super.apply(this, arguments);
  }

  _createClass(ListValueSource, [{
    key: "getValue",
    value: function getValue(input) {
      var _this = this;

      return input.map(function (_ref) {
        var valueSource = _ref.valueSource,
            valueSourceInput = _ref["".concat(valueSource, "Input")];

        return _this.targetComponentInstance.calculateValueDefinition(valueSource, valueSourceInput, _this.context);
      });
    }
  }], [{
    key: "getInputEditForm",
    value: function getInputEditForm(_ref2) {
      var customConditions = _ref2.customConditions,
          customVariables = _ref2.customVariables,
          editFormUtils = _ref2.editFormUtils,
          excludeConditions = _ref2.excludeConditions,
          excludeValueSources = _ref2.excludeValueSources,
          excludeVariables = _ref2.excludeVariables;
      return {
        label: 'Values',
        input: true,
        type: 'editgrid',
        templates: {
          header: "<div class=\"row\">\n            <div class=\"col-sm-10\">Value</div>\n            <div class=\"col-sm-2\"></div>\n          </div>",
          row: function row(_ref3) {
            var flattenedComponents = _ref3.flattenedComponents,
                row = _ref3.row;

            function displayFullPath(componentPath) {
              return componentPath.map(function (pathPart, pathPartIndex) {
                var pathFlattenedComponents = flattenedComponents.componentPathInput.flattenComponents(pathPartIndex);
                var componentKey = pathFlattenedComponents.component.getView(pathPart.component);
                var inputName = "".concat(pathPart.indexType, "Index");
                var index = pathPart.indexType === 'same' ? 'Same Index' : pathFlattenedComponents[inputName] ? pathFlattenedComponents[inputName].getView(pathPart[inputName]) : '';
                return "".concat(componentKey).concat(index ? " [".concat(index, "]") : '');
              }).join('.');
            }

            var inputName = "".concat(row.valueSource, "Input");
            var value = row.valueSource === 'thisComponent' ? 'This Component Value' : row.valueSource === 'componentPath' ? displayFullPath(row[inputName]) : flattenedComponents[inputName] ? flattenedComponents[inputName].getView(row[inputName]) : '';
            return "<div class=\"row\">\n              <div class=\"col-sm-10\">".concat(value, "</div>\n              <div class=\"col-sm-2\">\n                <button class=\"btn btn-default btn-light btn-sm editRow\">E</button>\n                <button class=\"btn btn-danger btn-sm removeRow\">D</button>\n              </div>\n            </div>");
          }
        },
        addAnother: 'Add Value',
        saveRow: 'Save Value',
        components: _toConsumableArray(editFormUtils.valueDeclaration({
          customConditions: customConditions,
          customVariables: customVariables,
          excludeConditions: excludeConditions,
          excludeValueSources: [].concat(_toConsumableArray(excludeValueSources), [// Exclude current valueSource to prevent infinite recursion.
          _ConditionalAssignment.ConditionalAssignmentValueSource.name, ListValueSource.name]),
          excludeVariables: excludeVariables
        }))
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'list';
    }
  }, {
    key: "title",
    get: function get() {
      return 'List';
    }
  }, {
    key: "weight",
    get: function get() {
      return 470;
    }
  }]);

  return ListValueSource;
}(_ValueSource2.ValueSource);

exports.ListValueSource = ListValueSource;